export const iconUrls = {
  dogYes: 'https://assets.urbansitter.com/static/img/pets/dog-yes.png',
  dogNo: 'https://assets.urbansitter.com/static/img/pets/dog-no.png',
  dogUnknown: 'https://assets.urbansitter.com/static/img/pets/dog-unknown.png',
  catYes: 'https://assets.urbansitter.com/static/img/pets/cat-yes.png',
  catNo: 'https://assets.urbansitter.com/static/img/pets/cat-no.png',
  catUnknown: 'https://assets.urbansitter.com/static/img/pets/cat-unknown.png',
  otherYes: 'https://assets.urbansitter.com/static/img/pets/other-yes.png',
  otherNo: 'https://assets.urbansitter.com/static/img/pets/other-no.png',
  otherUnknown: 'https://assets.urbansitter.com/static/img/pets/other-unknown.png'
};
